import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY            || "AIzaSyBf6FG3hb1I8-ANFQb7z8M3RtsgX9D1P6k",
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN        || "origen-import.firebaseapp.com",
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID         || "origen-import",
  storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET     || "origen-import.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID|| "664493438198",
  appId:             process.env.REACT_APP_FIREBASE_APP_ID             || "1:664493438198:web:3314ec71da3f639c4468d7",
};

const app = initializeApp(firebaseConfig);

export const auth    = getAuth(app);
export const db      = getFirestore(app);
export const storage = getStorage(app);
export default app;
